<template>
  <div class="dialog-overlay" @click.self="$emit('close')">
    <div class="dialog-content">
      <div class="dialog-header">
        <h3 class="dialog-title">Change Category</h3>
        <button class="close-button" @click="$emit('close')">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="close-icon">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="dialog-body">
        <p class="dialog-description">
          Select a new category for the {{ selectedCount }} selected course(s).
        </p>
        
        <div class="field-group">
          <label for="category" class="field-label">Category</label>
          <select 
            id="category" 
            v-model="selectedCategory" 
            class="field-input"
            required
          >
            <option value="" disabled>Select a category</option>
            <option v-for="category in categories" :key="category.id" :value="category.id">
              {{ category.title }}
            </option>
          </select>
        </div>
      </div>
      
      <div class="dialog-footer">
        <button class="cancel-button" @click="$emit('close')">Cancel</button>
        <button 
          class="confirm-button" 
          :disabled="!selectedCategory" 
          @click="confirmChange"
        >
          Change Category
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangeCategoryDialog',
  props: {
    categories: {
      type: Array,
      required: true
    },
    selectedCount: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      selectedCategory: ''
    };
  },
  methods: {
    confirmChange() {
      if (this.selectedCategory) {
        console.log(`Changing category to: ${this.selectedCategory} for ${this.selectedCount} courses`);
        this.$emit('change', this.selectedCategory);
      }
    }
  }
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
  padding: 1rem;
  overflow-y: auto;
  animation: fade-in 0.2s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.dialog-content {
  background-color: white;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  animation: slide-up 0.3s ease-out;
}

@keyframes slide-up {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #E2E8F0;
  background: linear-gradient(135deg, #F8FAFC, #EEF2FF);
}

.dialog-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
}

.close-button {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #64748B;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: #F1F5F9;
  color: #1E293B;
}

.close-icon {
  width: 18px;
  height: 18px;
}

.dialog-body {
  padding: 1.5rem;
}

.dialog-description {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #475569;
  font-size: 0.875rem;
}

.field-group {
  margin-bottom: 1.5rem;
}

.field-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
}

.field-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #1E293B;
  background-color: #F8FAFC;
  transition: all 0.2s;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236366F1' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1rem;
  padding-right: 2.5rem;
}

.field-input:focus {
  outline: none;
  border-color: #6366F1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  background-color: white;
}

.dialog-footer {
  padding: 1.25rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  border-top: 1px solid #E2E8F0;
  background-color: #F8FAFC;
}

.cancel-button {
  padding: 0.75rem 1.25rem;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background-color: white;
  color: #64748B;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-button:hover {
  background-color: #F1F5F9;
  color: #334155;
}

.confirm-button {
  padding: 0.75rem 1.25rem;
  border: none;
  border-radius: 8px;
  background-color: #6366F1;
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-button:hover:not(:disabled) {
  background-color: #4F46E5;
  transform: translateY(-1px);
}

.confirm-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style> 